import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import BaseFeature from '../../foundation/base/base';

class Header extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.log('Header Feature Init');

		this.classes = {
			navIsOpen: 'is-open'
		};

		this.initDomCache();
		this.init();
	}

	init() {
		this.dom.navController.addEventListener('click', () => {
			this.setNavIsOpen();
		});
	}

	navIsOpen() {
		return this.dom.navController.checked;
	}

	setNavIsOpen() {
		const isNavOpen = this.navIsOpen();

		// Toggle the class based on our test
		this.el.classList.toggle(this.classes.navIsOpen, isNavOpen);

		// Lock scrolling on body
		if (isNavOpen) {
			disableBodyScroll(this.dom.navPanel, {
				reserveScrollBarGap: true
			});
		} else {
			clearAllBodyScrollLocks();
		}
	}

	static detectTab() {
		document.body.addEventListener('keydown', (event) => {
			if (event.keyCode === 9) {
				document.body.classList.remove('using-mouse');
				document.body.classList.add('using-tab');
			}
			document.body.removeEventListener('keydown', document.body);
		});

		// Re-enable focus styling when Tab is pressed
		document.body.addEventListener('mouseover', () => {
			document.body.classList.remove('using-tab');
			document.body.classList.add('using-mouse');
			document.body.removeEventListener('mouseover', document.body);
		});
	}

	static setAriaTags() {
		for (let i = 0; i < Header.primaryNavFirstLevelItem.length; i++) {
			Header.primaryNavFirstLevelItem[i].setAttribute('aria-haspopup', 'true');
			Header.primaryNavFirstLevelItem[i].setAttribute('aria-expanded', 'false');
			Header.primaryNavFirstLevelItem[i].setAttribute('role', 'menuitem');
		}
	}

	static desktopOpenMegaMenu() {
		const megaMenuContainer = Header.primaryNavigation.querySelectorAll('ul li ul');

		for (let i = 0; i < megaMenuContainer.length; i++) {
			megaMenuContainer[i].setAttribute('data-mega', 'mega-menu-container');
		}
		Header.primaryNavigation.addEventListener('keyup', () => {
			Header.closeLanguageNav();
			Header.primaryNavigation.removeEventListener('keydup', Header.primaryNavigation);
		});
		Header.primaryNavigation.addEventListener('keydown', (event) => {
			if (event.keyCode === 32) {
				event.preventDefault();
				Header.resetMainNav();
				if (event.target.getAttribute('data-nav') === 'nav-item-link') {
					event.target.parentNode.classList.add('first-level-open');
					event.target.parentNode.setAttribute('aria-expanded', 'true');
				}
			}
			Header.primaryNavigation.removeEventListener('keydown', Header.primaryNavigation);
		});

		// Nav:hover first level
		for (let i = 0; i < Header.primaryNavFirstLevelItem.length; i++) {
			Header.primaryNavFirstLevelItem[i].addEventListener('mouseover', (event) => {
				if (event.target.getAttribute('data-nav') === 'nav-item-link' && event.target.parentNode.parentNode.parentNode.getAttribute('data-nav') === 'primary-navigation') {
					Header.resetMainNav();
					event.target.parentNode.classList.add('first-level-open');
					event.target.parentNode.setAttribute('aria-expanded', 'true');
				}
			});

			Header.primaryNavFirstLevelItem[i].addEventListener('mouseout', (event) => {
				if (event.target.getAttribute('data-nav') === 'nav-item-link' && event.target.parentNode.parentNode.parentNode.getAttribute('data-nav') === 'primary-navigation') {
					event.target.parentNode.classList.remove('first-level-open');
					event.target.parentNode.setAttribute('aria-expanded', 'false');
				}
			});

			// Nav:hover Mega menu lists
			Header.primaryNavFirstLevelItem[i].addEventListener('mouseover', (event) => {
				if (event.target.getAttribute('data-nav') === 'nav-item-link' && event.target.parentNode.parentNode.parentNode.parentNode.parentNode.getAttribute('data-nav') === 'primary-navigation') {
					Header.closeLanguageNav();
					event.target.parentNode.parentNode.parentNode.classList.add('first-level-open');
					event.target.parentNode.parentNode.parentNode.setAttribute('aria-expanded', 'true');
				}
			});
		}

		// Nav:hover Mega menu
		for (let i = 0; i < megaMenuContainer.length; i++) {
			megaMenuContainer[i].addEventListener('mouseover', (event) => {
				if (event.target.getAttribute('data-mega') === 'mega-menu-container') {
					event.target.parentNode.classList.add('first-level-open');
					event.target.parentNode.setAttribute('aria-expanded', 'true');
				}
			});
			megaMenuContainer[i].addEventListener('mouseout', (event) => {
				if (event.target.getAttribute('data-mega') === 'mega-menu-container') {
					event.target.parentNode.classList.remove('first-level-open');
					event.target.parentNode.setAttribute('aria-expanded', 'false');
				}
			});
		}
	}

	static resetMainNav() {
		if (document.querySelectorAll('.first-level-open').length) {
			const menuItems = document.querySelectorAll('[data-nav=nav-list-item]');
			document.activeElement.blur();
			for (let i = 0; i < menuItems.length; i++) {
				menuItems[i].classList.remove('first-level-open');
				menuItems[i].setAttribute('aria-expanded', 'false');
			}
		}
	}

	static showLanguageList() {
		Header.languagePopper.addEventListener('keydown', (event) => {
			if (event.keyCode === 32) {
				event.preventDefault();
				if (Header.languageContainer.classList.contains('o-nav__language-container--show-langugages')) {
					Header.closeLanguageNav();
				} else {
					Header.languageContainer.classList.add('o-nav__language-container--show-langugages');
					Header.languagePopper.setAttribute('aria-expanded', 'true');
					Header.languageLinksIndex('0');
				}
			}
			Header.languagePopper.removeEventListener('keydown', Header.languagePopper);
		});

		Header.searchLink.addEventListener('keyup', () => {
			Header.closeLanguageNav();
			Header.searchLink.removeEventListener('keyup', Header.searchLink);
		});

		// Header.languageNav.addEventListener('keyup', (event) => {
		// 	if (event.keyCode === 9) {
		// 		if (!event.target.hasAttribute('data-service')) {
		// 			Header.closeLanguageNav();
		// 		}
		// 	}
		// 	Header.languageNav.removeEventListener('keyup', Header.languageNav);
		// });
		Header.languagePopper.addEventListener('mouseover', () => {
			Header.openLanguageNav();
			Header.languagePopper.removeEventListener('mouseover', Header.languagePopper);
		});
		Header.languageContainer.addEventListener('mouseover', () => {
			Header.openLanguageNav();
			Header.languagePopper.removeEventListener('mouseover', Header.languagePopper);
		});
		Header.languageContainer.addEventListener('mouseout', () => {
			Header.closeLanguageNav();
			Header.languagePopper.removeEventListener('mouseout', Header.languagePopper);
		});
	}

	static openLanguageNav() {
		document.activeElement.blur();
		Header.languageContainer.classList.add('o-nav__language-container--show-langugages');
		Header.languagePopper.setAttribute('aria-expanded', 'true');
		Header.languageLinksIndex('0');
	}

	static closeLanguageNav() {
		Header.languageContainer.classList.remove('o-nav__language-container--show-langugages');
		Header.languagePopper.setAttribute('aria-expanded', 'false');
		Header.languageLinksIndex('-1');
	}

	static languageLinksIndex(state) {
		for (let i = 0; i < Header.languageLinks.length; i++) {
			Header.languageLinks[i].setAttribute('tabindex', state);
		}
	}
}

Header.primaryNavigation = document.querySelector('[data-nav=primary-navigation]');
Header.primaryNavList = document.querySelector('[data-nav=primary-navigation] > [data-nav=nav-list]');
Header.primaryNavFirstLevelItem = document.querySelectorAll('[data-nav=primary-navigation] > [data-nav=nav-list] > [data-nav=nav-list-item]');

Header.languageNav = document.querySelector('[data-service=language-nav]');
Header.languagePopper = document.querySelector('[data-service=language-popper]');
Header.languageContainer = document.querySelector('[data-service=language-container]');
Header.languageLinks = document.querySelectorAll('[data-service=language-link]');
Header.searchLink = document.querySelector('[data-service=search-link]');

Header.detectTab();
Header.setAriaTags();
Header.desktopOpenMegaMenu();
Header.showLanguageList();
Header.languageLinksIndex('-1');

export default Header;
